var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"scroll":{ x: 1500, },"data":_vm.measures,"loading":_vm.loading,"pagination":_vm.pagination,"columns":_vm.columns,"custom-row":_vm.customRow},on:{"change":_vm.handleTableChange}})}
var staticRenderFns = []

export { render, staticRenderFns }